import { alpha } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/material/styles';

const selectMenuItemBase = (theme: Theme) => ({
  display: 'flex',
  gap: theme.spacing(1.25),
  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  '&.Mui-selected:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
  },
});

/**
 * `AgeSelect`'s row layout — checkbox flush against the label on the left
 * (the default flex-start; nothing explicit needed beyond the shared base).
 */
export const selectMenuItemSx: SxProps<Theme> = (theme) => selectMenuItemBase(theme);

/** `SingleSelect`'s row layout — label left, tick at the far right. */
export const selectMenuItemRightSx: SxProps<Theme> = (theme) => ({
  ...selectMenuItemBase(theme),
  justifyContent: 'space-between',
});

export const selectCheckboxSx: SxProps<Theme> = (theme) => ({
  padding: 0,
  color: theme.palette.divider,
  '&.Mui-checked': { color: theme.palette.primary.main },
});

/** Selected row's label — bold + primary color, matching the checked checkbox. */
export const selectSelectedLabelSx: SxProps<Theme> = (theme) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.primary.main,
});
